import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { SVGComponentProps } from '../type';

const CallIcon: React.FC<SVGComponentProps> = ({
  width = 14,
  height = 14,
  stroke = 'black',
  ...props
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.33392 4.89833C4.79792 5.86474 5.43044 6.7705 6.2315 7.57155C7.03255 8.37261 7.93831 9.00513 8.90472 9.46913C8.98785 9.50904 9.02941 9.529 9.08201 9.54433C9.26891 9.59881 9.49842 9.55968 9.6567 9.44634C9.70124 9.41444 9.73935 9.37634 9.81556 9.30013C10.0486 9.06706 10.1652 8.95052 10.2823 8.87433C10.7243 8.587 11.294 8.587 11.7359 8.87433C11.8531 8.95052 11.9696 9.06706 12.2027 9.30013L12.3326 9.43004C12.6869 9.78434 12.8641 9.96148 12.9603 10.1517C13.1517 10.5301 13.1517 10.977 12.9603 11.3553C12.8641 11.5456 12.6869 11.7227 12.3326 12.077L12.2275 12.1821C11.8745 12.5352 11.6979 12.7117 11.4579 12.8466C11.1916 12.9962 10.7779 13.1038 10.4724 13.1029C10.1971 13.102 10.009 13.0486 9.63267 12.9418C7.6104 12.3678 5.70216 11.2849 4.11018 9.69287C2.51819 8.10089 1.43521 6.19265 0.861227 4.17038C0.754423 3.79409 0.70102 3.60594 0.700201 3.33064C0.699292 3.02516 0.806867 2.6115 0.95648 2.34516C1.09131 2.10514 1.26785 1.9286 1.62094 1.57552L1.72602 1.47043C2.08032 1.11613 2.25747 0.938984 2.44772 0.842754C2.8261 0.651374 3.27294 0.651374 3.65131 0.842754C3.84157 0.938983 4.01871 1.11613 4.37301 1.47043L4.50292 1.60034C4.73599 1.83341 4.85253 1.94994 4.92872 2.06713C5.21605 2.50906 5.21605 3.07878 4.92872 3.5207C4.85253 3.63789 4.73599 3.75443 4.50292 3.9875C4.42671 4.0637 4.38861 4.10181 4.35672 4.14635C4.24338 4.30464 4.20424 4.53414 4.25872 4.72104C4.27405 4.77364 4.29401 4.8152 4.33392 4.89833Z"
        stroke={stroke}
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SVGUniqueID>
);

export { CallIcon };
